export default "__VITE_ASSET__DHSuJLaC__"